import { render, staticRenderFns } from "./RevenueList.vue?vue&type=template&id=bce667ce&scoped=true"
import script from "./RevenueList.vue?vue&type=script&lang=js"
export * from "./RevenueList.vue?vue&type=script&lang=js"
import style0 from "./RevenueList.vue?vue&type=style&index=0&id=bce667ce&prod&scoped=true&lang=css"
import style1 from "./RevenueList.vue?vue&type=style&index=1&id=bce667ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce667ce",
  null
  
)

export default component.exports